export { QRCodeComponent } from './components';
export { QRCodeModule } from './angularx-qrcode.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angularx-qrcode/dist/index.js
// module id = ./node_modules/angularx-qrcode/dist/index.js
// module chunks = 0